import { render, staticRenderFns } from "./LessPostSwiper.vue?vue&type=template&id=eb0a6488&"
import script from "./LessPostSwiper.vue?vue&type=script&lang=ts&"
export * from "./LessPostSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./LessPostSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports